<template>
    <div>
        <el-upload
            ref="upload"
            :auto-upload="false"
            :limit="1"
            :file-list="fileList"
            :on-preview="handlePictureCardPreview"
            :on-change="update"
            :on-remove="removeFile"
            class="user-file-upload"
            list-type="picture"
            action="#"
        >
            <el-button size="small" type="primary">{{ getVerbose('user_import_drop_file_text_emphasized') }}</el-button>
            <div slot="tip" class="el-upload__tip">jpg/png</div>
        </el-upload>
        <el-dialog
            :visible.sync="dialogVisible"
            :append-to-body="true"
            @close="dialogImageUrl = ''"
        >
            <img :src="dialogImageUrl" width="100%" alt="">
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    components: {},
    props: {
        value: {
            required: false,
        },
    },
    data() {
        return {
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'getVerbose',
        ])
    },
    watch: {
        value (val){
            if(typeof(val) === 'string' && val.length){
                this.getFileFromUrl();
            }
        }
    },
    created() {

    },
    mounted() {
    },
    methods: {
        async getFileFromUrl (){
            let response = await fetch(this.value);
            let data = await response.blob();
            let metadata = {
                type: data.type
            };
            let file = new File([data], `file.${data.type.match(/\w+\/(\w+)/)[1]}`, metadata);
            let fileFormattedForElUpload = {
                name: file.name,
                type: file.type,
                lastModified: file.lastModified,
                lastModifiedDate: file.lastModifiedDate,
                size: file.size,
                webkitRelativePath: file.webkitRelativePath,
                raw:file,
                url: this.value,
            };
            this.$set(this, 'fileList', [fileFormattedForElUpload]);
            this.update(fileFormattedForElUpload);
        },
        update (file){
            this.$emit('input', file.raw);
        },
        handlePictureCardPreview (file){
            let reader = new FileReader();
            reader.onload = (e) => {
                this.dialogImageUrl = e.target.result;
                this.dialogVisible = true;
            };
            reader.readAsDataURL(file.raw);
        },
        removeFile (file){
            // en attente de savoir comment setter un champs file à null
            // this.update({raw:null});
        },
    },
};

</script>
<style lang="scss">
.user-file-upload{
    line-height: normal;
    position: relative;
    .el-upload{
        text-align: left;
        .el-upload__input {
            display: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/user/formInputs/file.vue